<template>
  <div class="mt-12">
    <div class="flex flex-col items-start justify-between gap-32 lg:flex-row lg:gap-20">
      <div class="flex-1">
        <IAITab v-model="activeTab" :tabs="tabs">
          <template #about>
            <div class="mt-6">
              <pre class="whitespace-pre-line break-words font-sans text-sm font-normal text-theme-1">
                {{ profile.description }}
              </pre>
            </div>
          </template>

          <template #includes>
            <div class="mt-6">
              <ol class="list-inside">
                <li
                  v-for="item in profile.content_list"
                  :key="item"
                  class="mt-1 flex items-center font-sans text-sm font-normal text-theme-1"
                >
                  <img class="mr-2" :src="circleBullet.src" />

                  <span>{{ item }}</span>
                </li>
              </ol>
            </div>
          </template>
        </IAITab>
      </div>

      <div class="flex flex-col md:max-w-[400px]">
        <div class="font-sans text-sm font-semibold text-theme-1">
          {{ $t("pages.profile-shop.profile-details.tags") }}
        </div>

        <div class="mt-4">
          <Tags v-if="profile.bundle_tags" class="flex-wrap" :tag-list="formattedTags" size="large" :show-all="true" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { IAITab } from "@/core-ui-vue";
import Tags from "@/features/profile-shop/components/Tags.vue";
import type { IBundleDetailesResponse } from "@/features/sell-a-profile/services/api";
import circleBullet from "@/features/sell-a-profile/assets/bullet-points/circle.svg";
import type { Tab } from "@/core-ui-vue";
import { t } from "@/locales/vue";
import { universalStorage } from "@/utils/universal-storage";

const props = defineProps<{
  profile: IBundleDetailesResponse;
}>();

const activeTab = ref("about");

const tabs: Tab[] = [
  {
    label: t("pages.profile-shop.profile-details.about"),
    key: "about",
  },
  {
    label: t("pages.profile-shop.profile-details.includes"),
    key: "includes",
  },
];

const createTagLink = (group: string, key: string) => {
  const url = new URL("/profile-shop", universalStorage.get("url"));
  url.searchParams.set(group, key);
  return url.toString();
};

const formattedTags = computed(() => {
  if (!props.profile.bundle_tags) return [];

  return props.profile.bundle_tags.map((tag) => ({
    label: tag.label,
    link: createTagLink(tag.group, tag.key),
  }));
});
</script>
